/* eslint-disable react/no-unknown-property */
import Enllac from 'components/3catinfo/Enllac';
import { dataResources } from 'utils/constants';
import styles from './peu.module.scss';

const { basePath } = dataResources;

export default function Peu() {
    return (
        <>
            <style jsx>{`
                footer {
                    padding-left: 16px;
                    padding-right: 16px;
                }
                .footer_wrapper {
                    background-color: #111617;
                }
                .footer_pre {
                    color: #fff;
                    display: flex;
                    align-items: center;
                    padding: 0 16px;
                    max-width: 2144px;
                    margin: 0 auto;
                }
                .footer_pre_container {
                    padding: 48px 0;
                    display: flex;
                    flex-wrap: wrap;
                    gap: 32px;
                    align-content: center;
                    width: 100%;
                }
                .footer_pre_container div {
                    height: 30px;
                    align-items: center;
                    width: 100%;
                    justify-content: space-around;
                }
                .footer_pre_3cat {
                    display: flex;
                    flex-basis: 100%;
                    justify-content: center;
                }
                .footer_pre_logos {
                    display: flex;
                    justify-content: flex-end;
                    grid-area: logos;
                }
                .footer_pre_container .logos {
                    display: flex;
                    flex-wrap: nowrap;
                    align-items: end;
                }
                .footer_pre_links {
                    grid-area: links;
                    display: flex;
                    justify-content: flex-end;
                }
                .link:last-child {
                    margin: 0 0 0 16px;
                }
                .footer_post_container {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: flex-start;
                    padding: 0 0 32px;
                    max-width: 2144px;
                }
                .footer_line {
                    max-width: 2144px;
                    margin: 0 0 32px;
                }
                .footer_line div {
                    display: block;
                    height: 1px;
                    background: #21292c;
                }
                .footer_post_container div {
                    margin: 0 16px 16px 0;
                    white-space: nowrap;
                }
                .footer_post_copy {
                    color: #73868c;
                    padding-bottom: 32px;
                    font-weight: 700;
                }
            `}</style>
            <style global jsx>{`
                a {
                    text-decoration: none;
                }
                .footer_wrapper a {
                }
                .link a {
                    color: #ffffff;
                    transition: opacity 0.15s ease-in-out 0s;
                    font-size: 1.125rem;
                    font-weight: 700;
                }
                .footer_post_container a span {
                    color: #fff;
                    font-size: 14px;
                    font-weight: 700;
                    line-height: 20px;
                    transition: opacity 0.15s ease-in-out 0s;
                }
            `}</style>
            <footer data-testid='peu' aria-label='Peu de la CCMA' className='footer_wrapper'>
                <div className='footer_pre'>
                    <div className='footer_pre_container'>
                        <div className='footer_pre_3cat'>
                            <Enllac href='https://www.3cat.cat/3cat/'>
                                <amp-img
                                    src={basePath + '/_resources/logos/3cat.svg?v=2.2512.2'}
                                    width={97}
                                    height={28}
                                    className={styles.imgM}
                                    alt='3Cat'
                                />
                            </Enllac>
                        </div>
                        <div className='footer_pre_logos'>
                            <div className='logos'>
                                <Enllac href='https://www.3cat.cat/tv3/'>
                                    <amp-img
                                        src={basePath + '/_resources/logos/tv3_W.svg?v=2.2512.2'}
                                        width={36}
                                        height={28}
                                        className={styles.imgM}
                                        alt='TV3'
                                    />
                                </Enllac>
                            </div>
                            <div className='logos'>
                                <Enllac href='https://www.3cat.cat/catradio/'>
                                    <amp-img
                                        src={basePath + '/_resources/logos/cr_W.svg?v=2.2512.2'}
                                        width={34}
                                        height={30}
                                        className={styles.imgL}
                                        alt='Catalunya Ràdio'
                                    />
                                </Enllac>
                            </div>
                            <div className='logos'>
                                <Enllac href='https://www.3cat.cat/3catinfo/'>
                                    <amp-img
                                        src={basePath + '/_resources/logos/info_W.svg?v=2.2512.2'}
                                        width={86}
                                        height={28}
                                        className={styles.imgS}
                                        alt='Info'
                                    />
                                </Enllac>
                            </div>
                            <div className='logos'>
                                <Enllac href='https://www.3cat.cat/tv3/sx3/'>
                                    <amp-img
                                        src={basePath + '/_resources/logos/sx3_W.svg?v=2.2512.2'}
                                        width={44}
                                        height={22}
                                        className={styles.imgS}
                                        alt='SX3'
                                    />
                                </Enllac>
                            </div>
                            <div className='logos'>
                                <Enllac href='https://www.3cat.cat/3cat/eva/'>
                                    <amp-img
                                        src={basePath + '/_resources/logos/eva_W.svg?v=2.2512.2'}
                                        width={50}
                                        height={22}
                                        className={styles.imgS}
                                        alt='EVA'
                                    />
                                </Enllac>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='footer_line'>
                    <div></div>
                </div>
                <div className='footer_post_container'>
                    <div>
                        <Enllac href='https://www.3cat.cat/avis-legal/'>
                            <span>Avís legal</span>
                        </Enllac>
                    </div>
                    <div>
                        <Enllac href='https://www.3cat.cat/canal-etic/'>
                            <span>Canal Ètic</span>
                        </Enllac>
                    </div>
                    <div>
                        <Enllac href='https://www.3cat.cat/avis-legal/cookies/'>
                            <span>Cookies</span>
                        </Enllac>
                    </div>
                    <div>
                        <Enllac href='https://www.3cat.cat/avis-legal/privacitat/delegat-de-proteccio-de-dades/'>
                            <span>Delegat de protecció de dades</span>
                        </Enllac>
                    </div>
                    <div>
                        <Enllac href='https://www.3cat.cat/atencio/accessibilitat/'>
                            <span>Accessibilitat</span>
                        </Enllac>
                    </div>
                    <div>
                        <Enllac href='https://www.3cat.cat/atencio/mapaweb/'>
                            <span>Mapa web</span>
                        </Enllac>
                    </div>
                </div>
                <div className='footer_post_copy'>© 3Cat</div>
            </footer>
        </>
    );
}
